/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

/**
 * Valide une mention (section « INFORMATION DE LA MENTION »).
 *
 * Obligatoires : numéro, date d'apposition, titre, code ANTS.
 * Non obligatoire : texte.
 *
 * Les clés correspondent aux `name` des champs du `MentionForm`.
 *
 * @param mention Données de la mention en cours de saisie.
 */
const validationInformationsMention = (mention: Record<string, any>) => {
  const errors = {
    numero: '',
    dateApposition: '',
    titre: '',
    codeAnts: '',
  };

  if (_.isEmpty(_.toString(mention?.numero))) {
    errors.numero = 'Le numéro est obligatoire';
  }

  if (_.isEmpty(mention?.dateApposition)) {
    errors.dateApposition = "La date d'apposition est obligatoire";
  }

  if (_.isEmpty(mention?.titre)) {
    errors.titre = 'Le titre est obligatoire';
  }

  if (_.isNil(mention?.codeAnts) || mention.codeAnts === '') {
    errors.codeAnts = 'Le code ANTS est obligatoire';
  }

  return _.pickBy(errors, (value) => value !== '');
};

export default validationInformationsMention;
